// RemitoComanda.jsx (plantilla con estructura de remito real)
import React from "react";
import moment from "moment";
import logo from "../images/DANLU_logo_transparent.png";

const RemitoComanda = React.forwardRef(({ data }, ref) => {
  const comanda = data;

  return (
    <div
      ref={ref}
      style={{
        width: "16cm",
        height: "20.7cm",
        minHeight: "21.7cm",
        padding: "30px",
        fontFamily: "Arial, sans-serif",
        border: "1px solid #000",
        fontSize: "12px",
        boxSizing: "border-box",
        overflow: "hidden"
      }}
    >
      {/* Encabezado */}
<div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
  {/* Columna Izquierda: Logo + Texto */}
  <div style={{ textAlign: "center", width: "33%" }}>
    <img
      src={logo}
      alt="Logo"
      style={{ height: "100px", objectFit: "contain", padding: "5px" }}
    />
    <div style={{ fontSize: "12px", marginTop: "5px", lineHeight: "1.2" }}>
      <div><strong>Transporte Danlu SRL</strong></div>
      <div>San Juan 297</div>
      <div>SM de Tucumán - CP:4000</div> 
      <div>Tel: 0381-422-1234</div>
    </div>
  </div>

  {/* Columna Centro: Documento no válido */}
  <div style={{ width: "33%", display: "flex", justifyContent: "center", alignItems: "center" }}>
    <div style={{ textAlign: "center", border: "1px solid black", padding: "10px" }}>
      <div style={{ fontSize: "24px", fontWeight: "bold" }}>X</div>
      <div style={{ fontSize: "10px" }}>DOCUMENTO<br />NO VÁLIDO COMO<br />FACTURA</div>
    </div>
  </div>

  {/* Columna Derecha: Remito y Fecha */}
  <div style={{ textAlign: "right", width: "33%" }}>
    <h1 style={{ margin: 0 }}>REMITO</h1>
    <div style={{ fontSize: "14px" }}>N° 0000-{comanda?.nroviaje || "------"}</div>
    <div style={{ fontSize: "12px", marginTop: "5px" }}>FECHA</div>
    <div style={{ border: "1px solid black", padding: "5px", display: "inline-block" }}>
      {comanda?.fecha ? moment(comanda.fecha).format("DD/MM/YYYY") : "--/--/----"}
    </div>
  </div>
</div>


<div style={{ marginTop: "10px", borderTop: "1px solid black", paddingTop: "10px" }}>
  <div style={{ fontSize: "12px" }}>
    <strong>Razón Social:</strong> {comanda?.codclif?.razonsocial || "--------"}
  </div>
  <div style={{ fontSize: "12px", marginTop: "4px" }}>
    <strong>Domicilio:</strong> {comanda?.codclif?.domicilio || "--------"}
  </div>
</div>


      {/* Tabla */}
      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid black", width: "10%", padding: "5px" }}>CANT.</th>
            <th style={{ border: "1px solid black", width: "90%", padding: "5px" }}>DETALLE</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ border: "1px solid black", padding: "10px" }}>1</td>
            <td style={{ border: "1px solid black", padding: "10px" }}>
              {comanda?.codpro?.producto || "Producto sin definir"} - {comanda?.kgsal?.toLocaleString("es-AR", { minimumFractionDigits: 2 }) || "0.00"} kg
            </td>
          </tr>

          {[...Array(9)].map((_, i) => (
            <tr key={i}>
              <td style={{ border: "1px solid black", padding: "10px" }}></td>
              <td style={{ border: "1px solid black", padding: "10px" }}></td>
            </tr>
          ))}
        </tbody>

      </table>

      {/* Observaciones */}
      <div style={{ marginTop: "20px" }}>
        <div style={{ fontWeight: "bold" }}>Observaciones:</div>
        <div style={{ minHeight: "40px", border: "1px solid black", padding: "10px" }}>
          {comanda?.observ || ""}
        </div>
      </div>
    </div>
  );
});

export default RemitoComanda;



// // RemitoComanda.jsx
// import React from "react";
// import moment from "moment";
// import logo from "../images/DANLU_logo_transparent.png";

// const RemitoComanda = React.forwardRef(({ data }, ref) => {
//   const comanda = data;
//   return (
//     <div ref={ref} style={{ padding: 30, fontFamily: 'Arial', maxWidth: '800px', margin: '0 auto', fontSize: 14 }}>
// <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//   <img src={logo} alt="Logo" style={{ height: 80 }} />
//   <h1 style={{ fontSize: 28 }}>REMITO</h1>
// </div>

//       <hr style={{ margin: '10px 0' }} />
//       <p><strong>Fecha de Viaje:</strong> {comanda?.fecha ? moment(comanda.fecha).format("DD/MM/YYYY HH:mm") : "-"}</p>
//       <p><strong>Nro de Viaje:</strong> {comanda?.nroviaje || "-"}</p>
//       <p><strong>Empresa:</strong> {comanda?.codemp?.empresa || "-"}</p>
//       <p><strong>Transporte:</strong> {comanda?.codtra?.transporte || "-"}</p>
//       <p><strong>Chofer:</strong> {comanda?.codcho?.nombre || "-"}</p>
//       <p><strong>Camión:</strong> {comanda?.codcam?.camion || "-"}</p>
//       <p><strong>Producto:</strong> {comanda?.codpro?.producto || "-"}</p>
//       <p><strong>Cliente Carga:</strong> {comanda?.codclif?.razonsocial || "-"}</p>
//       <p><strong>Cliente Descarga:</strong> {comanda?.codclid?.razonsocial || "-"}</p>
//       <p><strong>Origen:</strong> {comanda?.codori?.destino || "-"}</p>
//       <p><strong>Destino:</strong> {comanda?.coddes?.destino || "-"}</p>
//       <p><strong>Kg Salida:</strong> {comanda?.kgsal?.toLocaleString("es-AR", { minimumFractionDigits: 2 }) || "-"}</p>
//       <p><strong>Kg Llegada:</strong> {comanda?.kglle?.toLocaleString("es-AR", { minimumFractionDigits: 2 }) || "-"}</p>
//       <p><strong>Diferencia:</strong> {comanda?.dif?.toLocaleString("es-AR", { minimumFractionDigits: 2 }) || "-"}</p>
//       <p><strong>Total Facturado:</strong> {comanda?.total?.toLocaleString("es-AR", { style: 'currency', currency: 'ARS' }) || "-"}</p>
//       <p><strong>Observaciones:</strong> {comanda?.observ || "-"}</p>
//       <div style={{ marginTop: 40 }}>
//         <p style={{ fontSize: 12, textAlign: "center" }}>
//           Documento generado automáticamente - Sistema DANLU
//         </p>
//       </div>
//     </div>
//   );
// });

// export default RemitoComanda;
